export const DryingQualityRatingAttributeNames = [
  "dryingSpeed" , 
  "flow" ,
  "roomTemperature" , 
  "roomHumidity"] as const

export type DryingQualityRatingAttribute = typeof DryingQualityRatingAttributeNames[number];
export type DryingQualityRating = {
  [Attribute in DryingQualityRatingAttribute]: number | null;
}
